import React, { useState, useRef, useEffect, ReactElement } from 'react';
import styles from './Select.scss';
import Tooltip from '../Tooltip';
import MuiSelect from '../MaterialUi/Select';

export interface ISelectProps {
    className?: string;
    value: string;
    name: string;
    label: string;
    tooltip?: string | ReactElement; // info icon
    onChange: (name: string, value: number) => void;
}

const Select: React.FC<React.PropsWithChildren<ISelectProps>> = ({ value, name, label, onChange, children, className = '', tooltip = null }) => {
    const handleChange = (ev) => {
        const value = parseFloat((ev.target as HTMLFormElement).value);
        onChange(name, value);
    };

    return (
        <div className={styles.Select + ' ' + className}>
            <div className={styles.label}>
                {label}
                {tooltip && (
                    <>
                        {' '}
                        <Tooltip>{tooltip}</Tooltip>
                    </>
                )}
            </div>
            <div>
                <MuiSelect
                    // label={title || 'Bitte auswählen:'}
                    // label={''}
                    name={name}
                    value={value}
                    onChange={handleChange}
                    fullWidth
                >
                    {children}
                </MuiSelect>
            </div>
        </div>
    );
};

export default Select;
